import type { WorkerSchema } from '../types'
import { BILLIN_LINE_DEEP_LINK } from '../utils/billinLineDeepLink'

export const BillLinExpenseSchema: WorkerSchema = {
  workerId:     'bill-lin-expense',
  workerLabel:  '💸 รายจ่าย',
  tabIcon:      'receipt',
  recordPrefix: 'EX',
  apiEndpoint:  '/api/v1/transactions?worker=bill-lin-expense',
  // Queue/filter date = created_at (เวลาสร้าง), not last touch or receipt day.
  defaultSort:  { col: 'created_at', dir: 'desc' },
  searchFields: ['vendor','category','remark'],

  columns: [
    { id:'created_at', header:'วันที่', type:'datetime', editable:false, sortable:true, visibility:'always', width:150 },
    { id:'record_date', header:'วันที่บันทึก', type:'datetime', editable:false, sortable:true, visibility:'hidden', width:150 },
    { id:'updated_at', header:'อัปเดตล่าสุด', type:'datetime', editable:false, sortable:true, visibility:'hidden', width:150 },
    { id:'vendor', header:'ร้านค้า', type:'text', editable:true, visibility:'always' },
    { id:'amount', header:'จำนวน', type:'amount', editable:false, sortable:true, visibility:'always', align:'right' },
    { id:'category', header:'หมวด', type:'text', editable:true, visibility:'always' },
    { id:'document_type', header:'ประเภทเอกสาร', type:'text', editable:true, visibility:'always' },
    { id:'tax_doc', header:'VAT/เอกสาร', type:'text', editable:false, visibility:'always' },
    { id:'accounting_export', header:'ส่งบัญชี', type:'text', editable:false, visibility:'always' },
    { id:'status', header:'สถานะ', type:'status', editable:false, visibility:'always' },
    // Live mirror status only (plan §20 G0) — not the accounting export column
    { id:'google_mirror', header:'สำเนา Google', type:'text', editable:false, visibility:'always' },
    { id:'image_url', header:'ใบเสร็จ', type:'image', editable:false, visibility:'hidden' },
    { id:'record_id', header:'รหัส', type:'id', editable:false, copyable:true, visibility:'hidden' },
    { id:'payment_channel', header:'ช่องทางจ่าย', type:'text', editable:true, visibility:'hidden' },
    { id:'tax_invoice', header:'ใบกำกับภาษี', type:'status', editable:true, visibility:'hidden' },
    { id:'receipt_date', header:'วันที่ในใบเสร็จ', type:'date', editable:true, visibility:'hidden' },
    { id:'seller_tax_id', header:'Tax ID ผู้ขาย', type:'text', editable:true, copyable:true, visibility:'hidden' },
    { id:'vat', header:'VAT (฿)', type:'amount', editable:false, visibility:'hidden', align:'right' },
    { id:'remark', header:'หมายเหตุ', type:'text', editable:true, visibility:'hidden' },
    { id:'job_type', header:'ประเภทงาน', type:'text', editable:false, visibility:'hidden' },
  ],

  drawerSections: [
    { label: 'EXPENSE', fields: ['amount','payment_channel','vendor','receipt_date','category','document_type','tax_doc','accounting_export','google_mirror','image_url'] },
    { label: 'TAX', fields: ['tax_invoice','seller_tax_id','vat'] },
    { label: 'DETAILS', fields: ['remark','record_id'] },
  ],

  filterOptions: {
    status: ['✅ บันทึกแล้ว','🔴 บันทึกล้มเหลว'],
    datePresets: ['วันนี้','7 วันที่ผ่านมา','เดือนนี้','เดือนที่แล้ว','กำหนดเอง'],
    categories: ['วัตถุดิบ/สินค้า','ค่าขนส่ง/จัดส่ง','ค่าบรรจุภัณฑ์','ค่าเช่า',
                 'ค่าสาธารณูปโภค','ค่าจ้าง/เงินเดือน','ค่าการตลาด/โฆษณา',
                 'ค่าอุปกรณ์/ครุภัณฑ์','ค่าซ่อมบำรุง','ค่าธรรมเนียม/บริการ','ค่าใช้จ่ายเบ็ดเตล็ด'],
    document_type: ['receipt','invoice'],
  },

  emptyState: {
    icon: '🧾',
    title: 'ยังไม่มีรายจ่าย',
    body: 'forward ใบเสร็จหรือบิลไปที่ @HireAera เพื่อเริ่มบันทึก',
    cta: { label: 'เปิด LINE แชท @HireAera', href: BILLIN_LINE_DEEP_LINK },
  },

  drawerActions: [
    { id: 'download-summary', label: 'ดาวน์โหลดสรุป', variant: 'primary' },
  ],
  historyEnabled: true,
}
